import React from 'react';
import { useTheme } from '@material-ui/core';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { useStyles } from './styles';

interface IStaffDonutChart {
  data: any;
  tooltip?: boolean;
}

const StaffDonutChart: React.FC<IStaffDonutChart> = ({ data, tooltip }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <Chart
        options={{
          chart: {
            type: 'donut',
            redrawOnParentResize: true,
            redrawOnWindowResize: true,
            width: '100%',
            height: '100%',
            sparkline: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
            fontFamily: 'Poppins',
          },
          plotOptions: {
            pie: {
              expandOnClick: false,
              donut: {
                size: '55%',
              },
              dataLabels: {
                offset: -16,
              },
            },
          },
          dataLabels: {
            enabled: true,
            formatter(val, opts) {
              return `${opts.w.config.labels[opts.seriesIndex]}:
              ${opts.w.config.series[opts.seriesIndex]}`;
            },
            style: {
              fontSize: '14px',
              fontFamily: 'Poppins',
              fontWeight: 'bold',
            },
            background: {
              enabled: true,
              // padding: 24,
              borderRadius: 8,
              borderWidth: 1,
              foreColor: '#000',
              borderColor: '#fff',
              opacity: 1,
              dropShadow: {
                enabled: true,
                top: 2,
                left: 1,
                blur: 1,
                color: '#000',
                opacity: 0.25,
              },
            },
            dropShadow: {
              enabled: false,
            },
          },
          stroke: {
            show: false,
          },
          xaxis: {
            categories: [
              t('screens:dimensioning.structuralInspector'),
              t('screens:dimensioning.mechanicalInspector'),
              t('screens:dimensioning.electrician'),
            ],
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
            labels: {
              show: false,
            },
          },
          yaxis: {
            axisBorder: {
              show: false,
            },
            labels: {
              align: 'center',
            },
          },
          tooltip: {
            enabled: tooltip,
            custom: ({ series, seriesIndex, w }) => {
              return (
                '<div>' +
                '<span>' +
                `${w.globals.labels[seriesIndex]}: ${series[seriesIndex]}` +
                '</span>' +
                `</div>`
              );
            },
          },
          colors: [theme.charts.urgent, '#EAAA35', theme.charts.low],
          legend: {
            show: false,
          },
          labels: [
            t('screens:dimensioning.corrective'),
            t('screens:dimensioning.conditional'),
            t('screens:dimensioning.preventive'),
          ],
        }}
        series={data}
        type="donut"
        width={360}
      />
    </div>
  );
};

export default StaffDonutChart;
